<template>
  <div
    class="coupon-center-box"
  >
    <H5Header v-if="isNativeWebUIType"/>
    <div class="main" v-if="isLogin">
      <Available 
      ref="Available"
      @get-request-complete="getRequestComplete" @get-request-status="getRequestStatus"
      />
      <PackageMarket 
      @get-request-complete="getRequestComplete"
      @get-request-status="getRequestStatus"
       />
    </div>
    <LoginPage 
      v-else 
      @update-login="updateLogin"
    />
    <template v-if="isLogin">
      <!-- loding -->
       <NetworkPage
        v-if="isNetworkError"
        @update-again="updateAgain" 
      />
      <MaskLoading 
        :isFromTab="isFromTab"
        :allRequestComplete="allRequestComplete"
      />
    </template>
  </div>
</template>

<script>
import H5Header from './components/header/index.vue'
import Available from './components/available/index.vue'
import PackageMarket from './components/packageMarket/index.vue'
import MaskLoading from './components/mask/index.vue'
import LoginPage from '@/components/abnormal-page/login.vue'
import NetworkPage from '@/components/abnormal-page/network.vue'
import { couponPackageCenterSw, couponPackageCouponsCk } from './trackEvent'
import { get } from 'lodash-es'

export default {
  components: {
    H5Header,
    Available,
    PackageMarket,
    MaskLoading,
    LoginPage,
    NetworkPage
  },
  beforeRouteEnter: (to, from, next) => {
     Soda.getUserInfo({}, data => {
        // 判断是否有用户token
        let isLogin = false
        if (data && get(data, 'data.token', '')) {
          isLogin = true
        }
        next(vm => {
          vm.isLogin = isLogin
        })
      })
  },
  data () {
    return {
      isLogin:false,
      availableIsNetworkError:false,
      packageMarketIsNetworkError:false,
      available: {
        status: false,
        available_num: 0
      },
      packageMarket: {
        status: false,
        package_market_num: 0
      }
    }
  },
  computed: {
    isNativeWebUIType() {
      return +this.params.nativeWebUIType === 1
    },
    allRequestComplete () {
      return this.available.status && this.packageMarket.status
    },
    isFromTab() {
       return +this.params.fromTab === 1
    },
    // 埋点来源
    trackOrigin() {
      // 如果是底部tab进入的，埋点是food_tab
      if(this.isFromTab) return 'food_tab'
      return this.params.from || '未知来源'
    },
    isNetworkError() {
      return this.availableIsNetworkError || this.packageMarketIsNetworkError
    },
  },
  watch: {
    allRequestComplete (newV) {
      if (newV) {
        couponPackageCenterSw({
          available_num: this.available.available_num,
          package_market_num: this.packageMarket.package_market_num,
          is_cgc_activity: 2, // 暂无cgc推荐活动
          from: this.trackOrigin
        })
      }
    }
  },
  created() {
    // 注册点击分享之后的回调事件。供端上触发
    if (Soda.customer) {
      Soda.customer.triggerShareButtonEvent = () => {
        this.rightClick()
      }
      Soda.customer.triggerTabShowEvent = () => {
        // 更新接口数据
        Soda.getUserInfo({}, data => {
        // 判断是否有用户token
        if (data && get(data, 'data.token', '')) {
          this.isLogin = true
          this.$refs.Available.initData(true)
        } else {
          this.isLogin = false 
        }
      })
      }
    }
  },
  mounted () {
    this._initTemplateData()
  },
  methods: {
    updateNav () {
      this.SodaBridge('updateNav', {
        sysStatusBar: 0, // 0黑色,1白色
        backBtn: {
          // 返回按钮
          // 如果是tab进入，隐藏，否则展示，tab进入默认隐藏
          alpha: this.isFromTab ? 0 : 1, // 透明度
          color: '#000000' // 字体颜色
        },
        title: {
          color: '#000000',
          alpha: 1,
          content: this.$t('FoodC_C_Coupon_package_aeUS'),
          position: this.isFromTab ? 'left' : 'center'  //如果是tab进入，left，否则center，left “left/center”
        },
        nav: {
          // titlebar背景条
          color: '#FFFFFF',
          alpha: 1
        },
        rightBtns: [ // titlebar右边按钮
          {
            name: 'shareBtn',
            alpha: 1,
            currentIcon: 'https://img0.didiglobal.com/static/soda_public/do1_e8QdxjQyfzpLv2vg2ghN', // 实际图 cdn链接
            preloadIcon: 'https://img0.didiglobal.com/static/soda_public/do1_e8QdxjQyfzpLv2vg2ghN', // 预加载图
            action: 'triggerShareButtonEvent'
          }
        ]
      })
    },
    _initTemplateData () {
      this.updateNav()
    },
    rightClick () {
      const CouponUrlDidi = 'https:\/\/c-h5.didi-food.com\/${locale}\/user\/validCouponInfo?nativeWebUIType=2' // eslint-disable-line
      const CouponUrl99 = 'https:\/\/food-c-h5.99app.com\/${locale}\/user\/validCouponInfo?nativeWebUIType=2'// eslint-disable-line
      let url = CouponUrlDidi
      if (this.getCountry === 'BR') {
        url = CouponUrl99
      }
      couponPackageCouponsCk({}, () => {
        window.SodaBridge('openPage', {
          target: 'blank',
          url
        })
      })
    },
    getRequestComplete (options) {
      if (options.type === 'available') {
        this.available.status = options.status
        this.available.available_num = options.available_num
      } else if (options.type === 'packageMarket') {
        this.packageMarket.status = options.status
        this.packageMarket.package_market_num = options.package_market_num
      }
    },
    updateLogin() {
      this.isLogin = true
    },
    updateAgain() {
      this.$router.go(0)
    },
    getRequestStatus(val) {
      if(val.type === 'available') {
        if(val.status === 'err') { // 网络异常
          this.availableIsNetworkError =  true
        }
      }else if (val.type === 'packageMarket') {
        if(val.status === 'err') { // 网络异常
          this.packageMarketIsNetworkError =  true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-center-box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main {
  flex: 1;
  overflow: auto;
  padding: 0 32px;
  background: #f3f3f3;
}
</style>
